import { TimeRange } from "@/types/time-range";

/**
 * InfluxDB terminology reference:
 * 
 * https://docs.influxdata.com/influxdb/v1.7/concepts/key_concepts/
 * 
 * For InfluxDB time series data (processed stats and the various debug mode stats) 
 * the backend returns an array of one or more series. We'll refer to it as 'seriesArray'
 * A 'series' is an object with `columns`, `name`, `values`, and possibly `tags` properties.
 * The `columns` property is an array of 'field keys', which are metric names in our case, e.g. `bytes`.
 * The `values` property is an array of 'points'.
 * A point represents a single data record, starting with a timestamp, followed by field values. It's like a row of values starting
 with a timestamp.
 * Values in a point, other than the timestamp, are known as 'field values'.
 */

export type Series = {
  columns: string[];
  name: string;
  tags?: {
    [propName: string]: string; // only `server` used as propName currently
  };
  values: SeriesPoint[];
};

// e.g. ["2019-10-10T08:50:00Z", 0, 0, null, 0...]
// export type SeriesPoint = (string | number | null)[];
export type SeriesPoint = any[];

export type SeriesByTimeRange = {
  [timeRange: string]: SeriesByChartID;
};

export type SeriesByTimeRangeStatus = {
  [timeRange: string]: DataStatus;
};

export type SeriesByTimeRangeLastFetched = {
  [timeRange: string]: number; // milliseconds, timestamp
};

export type SeriesByChartID = {
  [chartID: string]: Series[];
};

export type SeriesPayload = {
  timeRange: TimeRange;
  chartID: string;
  seriesArray: Series[];
};

export enum DataStatus {
  UNFETCHED = "unfetched",
  FETCHING = "fetching",
  FETCHED = "fetched",
  FAILED = "failed",
}
